import type { SchemaType } from 'src/modules/datahub/schemas/types'

export enum System {
  MEMBERSHIP_COMMUNITY = 'mem_community_consume'
}

export enum EventNames {
  CLICK_TO_OPEN_LIVE_SETUP = 'click to open live setup',
  TRY_TO_CREATE_LIVE = 'try to create a live',
  CLICK_TO_LIMIT_PUBLICATION = 'click to limit publication',
  SETUP_COMMUNITY = 'click to setup community'
}

export enum ScreenNames {
  COMMUNITY_VIEW = 'CommunityView',
  COMMUNITY_CREATE_VIEW = 'CommunityCreateView',
  COMMUNITY_CREATION_MODAL = 'community-creation-modal'
}

export enum ComponentNames {
  OPEN_LIVE_SETUP_BUTTON = 'OPEN_LIVE_SETUP_BUTTON',
  CREATE_LIVE_BUTTON = 'CREATE_LIVE_BUTTON'
}

export enum Platform {
  WEB = 'WEB'
}

export enum ResultType {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE'
}

export type SendEventParams = {
  schema: SchemaType
  system?: System
  dataVersion?: string
  eventVersion?: string
}
